import React from "react";
import "./Projects.css";
export const Projects = () => {
  return (
    <div className="gpt3__projects section__padding" id="Projects">
      <div className="gpt3__projects-card">
        <h1>GuestHomes App</h1>
        <h3>Personal project(deployed)</h3>
        <p>
          It's a hotel, lodges and commercial buildings leasing website. built
          using NodeJs and React.
        </p>
        <span className="gpt3__projects-card_Repolink">
          <a href="https://guesthomes.azurewebsites.net">
            GuestHomes webApp &rarr;
          </a>
        </span>
      </div>
      <div className="gpt3__projects-card">
        <h1>CakeSpot Bakery Website</h1>
        <h3>Company site(deployed)</h3>

        <p>
          Our home bakery business website, we use it to show-case our products
          to customers.
        </p>
        <span className="gpt3__projects-card_Repolink">
          <a href="https://www.cakespot-tz.com">cakespot-tz.com &rarr;</a>
        </span>
      </div>
      <div className="gpt3__projects-card">
        <h1>E-commerce shop Web App</h1>
        <h3>Personal Project(on-going)</h3>
        <p>
          An API built using Node.js and MongoDB which can be implemented to
          create base backend for an online shop
        </p>
        <span className="gpt3__projects-card_Repolink">
          <a href="https://documenter.getpostman.com/view/21318343/VUqmvevt">
            Documentation &rarr;{" "}
          </a>
        </span>
      </div>
      <div className="gpt3__projects-card">
        <h1>News Feed App</h1>
        <h3>Personal Project(deployed)</h3>
        <p>
          News feed web App, next.js web app that fetch news feed data from
          external API and publish them 24/7
        </p>
        <span className="gpt3__projects-card_Repolink">
          <a href="https://news360.vercel.app/">News360&deg; App &rarr; </a>
        </span>
      </div>
      <div className="gpt3__projects-card">
        <h1>Kodisha kwetu</h1>
        <h3>Personal project(on-going)</h3>
        <p>
          A platform that allow people to search and lease domestic tools like
          event mattresses, huge pots for cooking, server dishes in your localty
        </p>
      </div>
    </div>
  );
};
